import React, {Component} from 'react'
import {Modal, ModalBody, ModalHeader, Button, Input, ModalFooter, Label, FormGroup, Form} from "reactstrap"
import {FormattedMessage, injectIntl} from "react-intl"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faTimes} from "@fortawesome/pro-light-svg-icons"
import {getStoreCandidateJobOrderAlertRoute} from "../../../helpers/route";
import {handleRequestError, Request} from "../../../helpers/request";
import * as toast from "react-toastify";
import { detectLanguage } from '../../../helpers/i18n'

class SaveJobAlertModal extends Component {
    state = {
        loading: false,
        email: '',
        title: '',
    }

    handleFormSubmit = () => {
        const {intl} = this.props

        const data = {
            email: this.state.email ?? '',
            title: this.state.title ?? '',
            locale: detectLanguage(),
            salary_low: this.props.filters.salary?.min,
            salary_high: this.props.filters.salary?.max,
            location: this.props.filters.location,
            remote: this.props.filters.remote,
            business_unit: this.props.filters.business_unit,
            business_unit_category_id: this.props.filters.business_unit_category,
            search_string: this.props.filters.skills,
        }

        Request.post(getStoreCandidateJobOrderAlertRoute(), data)
            .then((data) => {
                toast.toast.success(intl.formatMessage({
                    id: "portfolio.jobs.save_alert_modal.toast.success",
                    defaultMessage: "Alerte créée avec succès"
                }));
                this.setState({email: '', title: '',});
                this.props.close()
            })
            .catch((e) => {
                handleRequestError(e);
            }).finally(() => {
                this.setState({loading: false});
            });
    }

    onEmailChange = (event) => {
        this.setState({email: event.target.value})
    }

    onTitleChange = (event) => {
        this.setState({title: event.target.value})
    }

    render() {

        const { intl } = this.props;

        return (
            <Modal className="alert-wrapper-modal active"
                   size='xl'
                   isOpen={this.props.isOpen}
                   toggle={this.props.close}>
                <ModalHeader>
                    <span className="cross-icon-modal" onClick={this.props.close}>
                        <FontAwesomeIcon icon={faTimes}/>&nbsp;
                    </span>
                </ModalHeader>
                <ModalBody className="popup-modal-content">
                    <div className="popup-head">
                        <h2 className='text-uppercase'>
                            <FormattedMessage
                                id="portfolio.jobs.save_alert_modal.title"
                                defaultMessage="Souhaitez vous recevoir une alerte d'offres sur ces critères ?"
                            />
                        </h2>
                    </div>
                    <Form>
                        <FormGroup className='form-group'>
                            <Label className="text-uppercase">
                                <FormattedMessage
                                    id="portfolio.jobs.save_alert_modal.inputs.email.label"
                                    defaultMessage="Votre Email"
                                />
                            </Label>
                            <Input value={this.state.email ?? ''}
                                   onChange={(event) => {
                                       this.onEmailChange(event)
                                   }}
                                   className="pb-2"
                                   placeholder={
                                       intl.formatMessage({
                                           id: "portfolio.jobs.save_alert_modal.inputs.email.placeholder",
                                           defaultMessage: "Entrez votre adresse email..."
                                       })
                                   }
                            />
                        </FormGroup>
                        <FormGroup className='form-group'>
                            <Label className="text-uppercase">
                                <FormattedMessage
                                    id="portfolio.jobs.save_alert_modal.inputs.title.label"
                                    defaultMessage="Titre de l'alerte"
                                />
                            </Label>
                            <Input value={this.state.title ?? ''}
                                   onChange={(event) => {
                                       this.onTitleChange(event)
                                   }}
                                   className="pb-2"
                                   placeholder={
                                       intl.formatMessage({
                                           id: "portfolio.jobs.save_alert_modal.inputs.title.placeholder",
                                           defaultMessage: "Donnez un titre à votre alerte"
                                       })
                                   }
                            />
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter className='d-md-flex justify-content-center text-center'>
                    <Button xs="2"
                            className="btn pink-btn-modal text-uppercase"
                            disabled={this.state.loading}
                            onClick={this.handleFormSubmit.bind(this)}>
                        <FormattedMessage
                            id="portfolio.jobs.save_alert_modal.buttons.save"
                            defaultMessage="Enregistrer ma recherche"
                        />
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}

SaveJobAlertModal.defaultProps = {
    filters: {},
    isOpen: false,
    close: null,
};

export default injectIntl(SaveJobAlertModal)
